import React from 'react';
import styled from 'styled-components';

import { Futura } from '~/styles';
import { media } from '~/utils';

export default function ({ org, large, onClick }) {
  return (
    <Wrapper large={large}>
      <Title>ミッション</Title>
      <Mission large={large}>{org.mission}</Mission>
      {!large && <SeeMore onClick={onClick}>SEE MORE</SeeMore>}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: ${(props) => (props.large ? 'auto' : '235px')};
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;

  ${media.mid`
    border-radius: 0;
  `}
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Mission = styled.div`
  padding: 20px 35px 0;
  padding-bottom: ${(props) => (props.large ? '40px' : 0)};
  font-size: 18px;
  line-height: 32px;
  height: ${(props) => (props.large ? 'auto' : '160px')};
  max-height: ${(props) => (props.large ? 'auto' : '160px')};
  overflow: hidden;
  text-align: justify;
  white-space: ${(props) => (props.lange ? 'pre-wrap' : 'normal')};
  letter-spacing: 1px;
`;

const SeeMore = styled(Futura)`
  position: absolute;
  font-size: 15px;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  z-index: 1;
  left: 35px;
  bottom: 10px;
`;
